document.addEventListener("DOMContentLoaded", function () {
  // ---------- Fusionner les lignes dupliquées (bundles multi-devises) ----------
  // Pour préserver le prix affiché d'un bundle, Shopify peut scinder un même
  // achat en plusieurs line items du même variant sur une même commande (ex:
  // conversion CZK -> une ligne de 6 + une ligne de 3 au lieu d'une ligne de
  // 9). Ça fait apparaître le même produit en double. Regroupe une liste
  // d'éléments DOM par "commande + variant" ; les éléments sans
  // data-variant-id/data-parent-order restent chacun dans leur propre groupe
  // (jamais fusionnés par erreur).
  function groupArkItemsByOrderAndVariant(items) {
    const groups = new Map();
    items.forEach(function (item, index) {
      const parentOrder = item.getAttribute('data-parent-order');
      const variantId = item.getAttribute('data-variant-id');
      const key = (parentOrder && variantId) ? (parentOrder + '::' + variantId) : ('unique-' + index);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });
    return groups;
  }

  // Additionne data-quantity sur un groupe, met à jour l'attribut et le texte
  // affiché sur l'élément gardé (le 1er), retourne le total.
  function mergeArkQuantity(group) {
    const keep = group[0];
    const total = group.reduce(function (sum, item) {
      const qty = parseInt(item.getAttribute('data-quantity'), 10);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0);
    keep.setAttribute('data-quantity', String(total));
    const qtyText = keep.querySelector('.quantity_customer_order .my-ark-text-inline');
    if (qtyText) qtyText.textContent = total;
    return total;
  }

  function setArkQuantityText(li, value) {
    const qtyText = li.querySelector('.quantity_customer_order .my-ark-text-inline');
    if (qtyText) qtyText.textContent = value;
  }

  // Fait correspondre le contrôle de sélection au nombre d'unités
  // disponibles sur la ligne : case à cocher pour 1 seule unité (tout ou
  // rien), champ nombre sinon. Sans effet sur la liste Précommande, qui n'a
  // pas de contrôle de sélection.
  function setArkControlForUnitCount(li, unitCount) {
    const control = li.querySelector('.ark-item-control');
    if (!control) return;

    const checkbox = li.querySelector('.ark-item-select');
    const qtyInput = li.querySelector('.ark-item-qty');

    if (unitCount === 1) {
      if (qtyInput) {
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.className = 'ark-item-select';
        cb.checked = true;
        control.replaceChild(cb, qtyInput);
      }
    } else if (checkbox) {
      const input = document.createElement('input');
      input.type = 'number';
      input.className = 'ark-item-qty';
      input.min = '0';
      input.max = String(unitCount);
      input.value = String(unitCount);
      control.replaceChild(input, checkbox);
    } else if (qtyInput) {
      qtyInput.max = String(unitCount);
      qtyInput.value = String(unitCount);
    }
  }

  // ---------- Sets complets scellés (custom.full_set / full_set_quantity) ----------
  // Un produit acheté à l'unité peut aussi se vendre en set scellé de N
  // pièces à prix réduit (ex: 9 pièces). Shopify enregistre alors N line
  // items du produit individuel — impossible de distinguer visuellement
  // "9 pièces à l'unité" d'"1 set scellé de 9", et My Ark laissait
  // sélectionner une quantité intermédiaire (3, 4…) qui n'a pas de sens pour
  // un set scellé. Si la quantité totale (après fusion ci-dessus) atteint un
  // multiple de la taille du set, on affiche le/les set(s) comme un article
  // à part (titre du bundle, indivisible par set) ; ce qui dépasse reste
  // affiché comme des pièces individuelles normales.
  function applyArkBundleDisplay(li, title, url, image, bundleCount, fullSetQty) {
    li.setAttribute('data-quantity', String(bundleCount));
    li.setAttribute('data-piece-multiplier', String(fullSetQty));
    if (title) li.setAttribute('data-title', title);
    li.removeAttribute('data-full-set-qty');
    li.removeAttribute('data-full-set-title');

    const titleEl = li.querySelector('.title_customer_prod .my-ark-text-inline');
    if (titleEl && title) titleEl.textContent = title;

    // Le libellé de variante ("Default Title" mis à part) n'a plus de sens
    // une fois qu'on affiche le bundle plutôt que le produit individuel.
    const variantEl = li.querySelector('.variant_customer_prod');
    if (variantEl) variantEl.remove();

    if (url) {
      li.querySelectorAll('a[href]').forEach(function (a) { a.setAttribute('href', url); });
    }
    const img = li.querySelector('.image_customer_prod');
    if (img && image) img.setAttribute('src', image);

    setArkQuantityText(li, bundleCount);
    setArkControlForUnitCount(li, bundleCount);
  }

  // Retourne le(s) élément(s) DOM final(aux) pour ce <li> : soit lui-même
  // inchangé (pas de set complet applicable), soit transformé en ligne
  // "bundle" (+ une ligne sœur pour les pièces restantes le cas échéant).
  function splitArkBundle(li) {
    const fullSetQty = parseInt(li.getAttribute('data-full-set-qty'), 10);
    const fullSetTitle = li.getAttribute('data-full-set-title');
    if (!fullSetQty || fullSetQty <= 0 || !fullSetTitle) return [li];

    const totalQty = parseInt(li.getAttribute('data-quantity'), 10);
    if (isNaN(totalQty) || totalQty < fullSetQty) return [li];

    const bundleCount = Math.floor(totalQty / fullSetQty);
    const remainder = totalQty - bundleCount * fullSetQty;

    let remainderLi = null;
    if (remainder > 0) {
      // Cloné AVANT toute modification, pour garder le titre/l'image du
      // produit individuel sur les pièces qui ne font pas partie d'un set.
      remainderLi = li.cloneNode(true);
      remainderLi.removeAttribute('data-full-set-qty');
      remainderLi.removeAttribute('data-full-set-title');
      remainderLi.setAttribute('data-quantity', String(remainder));
      setArkQuantityText(remainderLi, remainder);
      setArkControlForUnitCount(remainderLi, remainder);
    }

    applyArkBundleDisplay(
      li,
      fullSetTitle,
      li.getAttribute('data-full-set-url'),
      li.getAttribute('data-full-set-image'),
      bundleCount,
      fullSetQty
    );

    if (remainderLi) {
      li.after(remainderLi);
      return [li, remainderLi];
    }
    return [li];
  }

  // ---------- Précommandes : regrouper par date d'arrivée ----------
  (function () {
    const flatList = document.querySelector(".pre_order_products_flat");
    const container = document.querySelector(".pre_order_products_all");

    if (!flatList || !container) return;

    let items = Array.from(flatList.querySelectorAll(".product_item"));
    flatList.remove();

    // Fusion des doublons AVANT le regroupement par date d'arrivée (les
    // lignes fusionnées ont forcément la même date, puisque même commande).
    const preOrderGroups = groupArkItemsByOrderAndVariant(items);
    items = [];
    preOrderGroups.forEach(function (group) {
      if (group.length > 1) mergeArkQuantity(group);
      items.push(group[0]);
      group.slice(1).forEach(function (item) { item.remove(); });
    });

    // Sets complets scellés : idem, avant le regroupement par date (un set
    // et ses pièces restantes partagent forcément la même commande/date).
    items = items.reduce(function (acc, li) {
      return acc.concat(splitArkBundle(li));
    }, []);

    const groups = {};
    items.forEach(item => {
      const fullArrival = item.dataset.arrival || '';
      // Ex: "MM/YYYY: texte" -> on garde MM/YYYY
      const arrivalDate = fullArrival.split(":")[0].trim() || 'Unknown';
      if (!groups[arrivalDate]) groups[arrivalDate] = [];
      groups[arrivalDate].push(item);
    });

    const sortedDates = Object.keys(groups).sort((a, b) => {
      if (a === 'Unknown') return 1;
      if (b === 'Unknown') return -1;
      // Parse "MM/YYYY"
      const [ma, ya] = a.split("/").map(Number);
      const [mb, yb] = b.split("/").map(Number);
      const da = isFinite(ma) && isFinite(ya) ? new Date(ya, (ma || 1) - 1, 1) : new Date(9999, 0, 1);
      const db = isFinite(mb) && isFinite(yb) ? new Date(yb, (mb || 1) - 1, 1) : new Date(9999, 0, 1);
      return da - db;
    });

    sortedDates.forEach(date => {
      const section = document.createElement("div");
      section.classList.add("pre_order_group");

      const heading = document.createElement("div");
      heading.classList.add("arrival_time_pre_upper");
      const headingText = document.createElement("span");
      headingText.classList.add("my-ark-text-inline");
      headingText.textContent = arrival_date_text + " " + (date === 'Unknown' ? 'Non précisé' : date);
      heading.appendChild(headingText);

      const ul = document.createElement("ul");
      ul.classList.add("pre_order_products");

      groups[date].forEach(item => ul.appendChild(item));
      section.appendChild(heading);
      section.appendChild(ul);
      container.appendChild(section);
    });
  })();

  // ---------- Fusionner les lignes dupliquées : Prêt à expédier ----------
  // Fait apparaître le même produit en double dans "Prêt à expédier". On
  // fusionne ici, avant les étapes suivantes (tout sélectionner, clamp, tri),
  // qui doivent voir le DOM déjà fusionné.
  (function () {
    const list = document.querySelector('.purchased_products');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('li[data-variant-id]'));
    const groups = groupArkItemsByOrderAndVariant(items);

    const keptItems = [];
    groups.forEach(function (group) {
      const total = mergeArkQuantity(group); // no-op si groupe d'1 seul élément
      const keep = group[0];
      setArkControlForUnitCount(keep, total);
      group.slice(1).forEach(function (li) { li.remove(); });
      keptItems.push(keep);
    });

    // Sets complets scellés : une fois les doublons de devise fusionnés.
    keptItems.forEach(function (li) { splitArkBundle(li); });
  })();

  // ---------- Tout sélectionner / Tout désélectionner ----------
  (function () {
    const selectAll = document.getElementById('ark-select-all');
    if (!selectAll) return;

    const getItems = () => Array.from(document.querySelectorAll('.purchased_products li[data-variant-id]'));

    function updateSelectAllState() {
      const items = getItems();
      if (!items.length) return;
      const allSelected = items.every(li => {
        const cb = li.querySelector('.ark-item-select');
        const qty = li.querySelector('.ark-item-qty');
        if (cb) return cb.checked;
        if (qty) return parseInt(qty.value, 10) > 0;
        return true;
      });
      selectAll.checked = allSelected;
    }

    selectAll.addEventListener('change', function () {
      const checked = this.checked;
      getItems().forEach(li => {
        const cb = li.querySelector('.ark-item-select');
        const qty = li.querySelector('.ark-item-qty');
        if (cb) {
          cb.checked = checked;
        } else if (qty) {
          qty.value = checked ? (li.getAttribute('data-quantity') || qty.max) : 0;
        }
      });
    });

    getItems().forEach(li => {
      const cb = li.querySelector('.ark-item-select');
      const qty = li.querySelector('.ark-item-qty');
      if (cb) cb.addEventListener('change', updateSelectAllState);
      if (qty) qty.addEventListener('input', updateSelectAllState);
    });

    updateSelectAllState();
  })();

  // ---------- Clamp visuel des sélecteurs de quantité ----------
  document.querySelectorAll('.ark-item-qty').forEach(input => {
    input.addEventListener('input', function () {
      const max = parseInt(this.max, 10);
      const val = parseInt(this.value, 10);
      if (!isNaN(val) && val > max) this.value = max;
      if (!isNaN(val) && val < 0) this.value = 0;
    });
  });

  // ---------- Tri "Prêt à expédier" par numéro de commande décroissant ----------
  (function () {
    const purchasedList = document.querySelector('.purchased_products');
    if (!purchasedList) return;

    const items = Array.from(purchasedList.querySelectorAll('li'));
    items.sort((a, b) => {
      const aNum = parseInt(a.querySelector('.id_customer_order')?.textContent.replace(/\D/g, '') || 0, 10);
      const bNum = parseInt(b.querySelector('.id_customer_order')?.textContent.replace(/\D/g, '') || 0, 10);
      return bNum - aNum;
    });
    items.forEach(item => purchasedList.appendChild(item));
  })();

  // ---------- Notification My Ark (ark-notify) ----------
  (function () {
    const toggle = document.getElementById('ark-notify-toggle');
    if (!toggle) return;

    toggle.addEventListener('change', async function () {
      const action = this.checked ? 'subscribe' : 'unsubscribe';
      const previous = !this.checked;
      try {
        const res = await fetch('/apps/ark/ark-notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action }),
          credentials: 'include'
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
      } catch (e) {
        console.error('ark-notify toggle error:', e);
        this.checked = previous;
      }
    });
  })();

  // ---------- Bouton "Créer la demande d'envoi" (checkout via App Proxy) ----------
  (function () {
    const readyBtn = document.querySelector('.readytoship_addtocart');
    if (!readyBtn) return;

    readyBtn.addEventListener('click', async function () {
      const loadingOverlay = document.getElementById('loading-overlay');
      if (loadingOverlay) loadingOverlay.style.display = 'flex';

      try {
        // Collecte des items My Ark
        const lis = Array.from(document.querySelectorAll('.purchased_products li[data-variant-id]'));
        const items = lis.map(li => {
          const checkbox = li.querySelector('.ark-item-select');
          const qtyInput = li.querySelector('.ark-item-qty');

          let selectedQty;
          if (checkbox) {
            if (!checkbox.checked) return null;
            selectedQty = 1;
          } else if (qtyInput) {
            selectedQty = parseInt(qtyInput.value, 10);
            if (isNaN(selectedQty) || selectedQty <= 0) return null;
            const maxQty = parseInt(li.getAttribute('data-quantity') || '1', 10);
            selectedQty = Math.min(selectedQty, maxQty);
          } else {
            selectedQty = Math.max(1, parseInt(li.getAttribute('data-quantity') || '1', 10));
          }

          // Ligne "set complet" : data-quantity / le contrôle sont exprimés en
          // nombre de sets (bundleSets). Le serveur retrouve lui-même, à
          // partir des métachamps du produit, quel est le bundle et son
          // ghost — on ne lui envoie jamais d'ID de variant pour ça, juste
          // ce nombre. variantId/quantity restent le variant individuel et
          // la quantité en pièces, pour la vérification côté serveur.
          const bundleSets = selectedQty;
          const pieceMultiplier = parseInt(li.getAttribute('data-piece-multiplier'), 10) || 1;
          selectedQty = selectedQty * pieceMultiplier;

          const variantIdRaw = li.getAttribute('data-variant-id');
          const variantGid = variantIdRaw ? `gid://shopify/ProductVariant/${variantIdRaw}` : null;

          const productTitle = li.querySelector('.title_customer_prod')?.textContent?.trim() || null;
          const variantTitle = li.querySelector('.variant_customer_prod')?.textContent?.trim() || null;

          return {
            variantId: variantGid,
            quantity: selectedQty,
            bundleSets: pieceMultiplier > 1 ? bundleSets : undefined,
            parentOrder: li.getAttribute('data-parent-order') || null,
            title: li.getAttribute('data-title') || productTitle || 'My Ark – Item',
            productTitle,
            variantTitle,
            weightGrams: parseInt(li.getAttribute('data-weight') || '0', 10) || 0,
            image: li.getAttribute('data-image') || null,
            priceEach: li.getAttribute('data-price') || null
          };
        }).filter(Boolean);

        if (!items.length) {
          alert('No available items to add to checkout.');
          if (loadingOverlay) loadingOverlay.style.display = 'none';
          return;
        }

        // Lecture de la checkbox
        const groupWithStock = document.getElementById('group-with-stock')?.checked === true;

        // Payload envoyé à l'App Proxy
        const payload = {
          items,
          note: groupWithStock ? 'Regrouper avec autres produits en stock' : null,
          noteAttributes: groupWithStock ? [{ name: 'group_with_other_stock', value: 'true' }] : []
        };

        // 1) Warmup pour le cookie Vercel
        try {
          await fetch('/apps/ark?warm=1', {
            method: 'GET',
            credentials: 'include'
          });
        } catch (e) {
          console.warn('Warmup failed (ignored):', e);
        }

        // 2) Appel réel à l'App Proxy (nouvelle app : subpath "ark")
        const draftUrl = '/apps/ark/create-draft' +
          (typeof ark_locale !== 'undefined' && ark_locale ? '?locale=' + encodeURIComponent(ark_locale) : '');
        const res = await fetch(draftUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'include'
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        console.log('My Ark response:', data);

        // Nouveau flux : checkout_url (Storefront). On garde invoice_url au cas où.
        const redirectUrl = data.checkout_url || data.invoice_url;

        const isValidRedirect = (url) => {
          try {
            const parsed = new URL(url);
            const safeHosts = ['checkout.shopify.com', window.location.hostname];
            return parsed.protocol === 'https:' && safeHosts.includes(parsed.hostname);
          } catch { return false; }
        };

        if (data?.status && redirectUrl && isValidRedirect(redirectUrl)) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 300);
        } else {
          alert(data?.message || 'Failed to create My Ark checkout. Please try again.');
        }
      } catch (e) {
        console.error(e);
        alert('Failed to create My Ark checkout.');
      } finally {
        if (loadingOverlay) loadingOverlay.style.display = 'none';
      }
    });
  })();
});
